// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Google font - Poppins */
.customCalender {
  width: 226px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
}

.customCalender header {
  display: flex;
  align-items: center;
  padding: 8px;
  justify-content: space-between;
  background-color: #003da5;
  color: white;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.customCalender header:hover {
  cursor: pointer;
}

header .icons {
  display: flex;
}

header .icons span {
  height: 38px;
  width: 38px;
  margin: 0 1px;
  cursor: pointer;
  color: #878787;
  text-align: center;
  line-height: 38px;
  font-size: 1.9rem;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
}

.icons span:last-child {
  margin-right: -10px;
}

header .icons span:hover {
  background: #f2f2f2;
}

header .current-date {
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  font-family: "Montserrat";
  margin-bottom: 0 !important;
}

.calendar {
  padding: 16px;
}

.calendar ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  text-align: center;
}

.calendar .days {
  margin-bottom: 20px;
}

.calendar li {
  color: #333;
  width: 14.2857142857%;
  font-size: 1.07rem;
}

.calendar .weeks li {
  font-weight: 500;
  cursor: default;
}

.calendar .days li {
  z-index: 1;
  cursor: pointer;
  position: relative;
  margin-top: 30px;
}

.days li.inactive {
  color: #aaa;
}

.days li.active {
  color: #fff;
}

.days li::before {
  position: absolute;
  content: "";
  left: 50%;
  top: 50%;
  height: 40px;
  width: 40px;
  z-index: -1;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.days li.active::before {
  background: #003da5;
}

.days li:not(.active):hover::before {
  background: #003da5;
}

.customCalender .leftArrow img,
.customCalender .rightArrow img {
  filter: invert(100%) sepia(100%) saturate(10000%) hue-rotate(180deg);
  transform: rotate(-90deg);
  width: 12px;
  height: 8px;
}

.customCalender .rightArrow img {
  transform: rotate(90deg);
}`, "",{"version":3,"sources":["webpack://./src/components/ACP/Planning/CustomCalender/CustomCalender.scss"],"names":[],"mappings":"AAAA,iCAAA;AAEA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;AAEF;AADE;EACE,eAAA;AAGJ;;AAAA;EACE,aAAA;AAGF;;AADA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AAIF;;AAFA;EACE,mBAAA;AAKF;;AAHA;EACE,mBAAA;AAMF;;AAJA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,2BAAA;AAOF;;AALA;EACE,aAAA;AAQF;;AANA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AASF;;AAPA;EACE,mBAAA;AAUF;;AARA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;AAWF;;AATA;EACE,gBAAA;EACA,eAAA;AAYF;;AAVA;EACE,UAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAaF;;AAXA;EACE,WAAA;AAcF;;AAZA;EACE,WAAA;AAeF;;AAbA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;AAgBF;;AAdA;EACE,mBAAA;AAiBF;;AAfA;EACE,mBAAA;AAkBF;;AAfA;;EAEE,oEAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;AAkBF;;AAfA;EACE,wBAAA;AAkBF","sourcesContent":["/* Import Google font - Poppins */\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap\");\n.customCalender {\n  width: 226px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);\n}\n.customCalender header {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  justify-content: space-between;\n  background-color: #003da5;\n  color: #ffff;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  &:hover{\n    cursor: pointer;\n  }\n}\nheader .icons {\n  display: flex;\n}\nheader .icons span {\n  height: 38px;\n  width: 38px;\n  margin: 0 1px;\n  cursor: pointer;\n  color: #878787;\n  text-align: center;\n  line-height: 38px;\n  font-size: 1.9rem;\n  user-select: none;\n  border-radius: 50%;\n}\n.icons span:last-child {\n  margin-right: -10px;\n}\nheader .icons span:hover {\n  background: #f2f2f2;\n}\nheader .current-date {\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 15px;\n  font-family: \"Montserrat\";\n  margin-bottom: 0 !important;\n}\n.calendar {\n  padding: 16px;\n}\n.calendar ul {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  text-align: center;\n}\n.calendar .days {\n  margin-bottom: 20px;\n}\n.calendar li {\n  color: #333;\n  width: calc(100% / 7);\n  font-size: 1.07rem;\n}\n.calendar .weeks li {\n  font-weight: 500;\n  cursor: default;\n}\n.calendar .days li {\n  z-index: 1;\n  cursor: pointer;\n  position: relative;\n  margin-top: 30px;\n}\n.days li.inactive {\n  color: #aaa;\n}\n.days li.active {\n  color: #fff;\n}\n.days li::before {\n  position: absolute;\n  content: \"\";\n  left: 50%;\n  top: 50%;\n  height: 40px;\n  width: 40px;\n  z-index: -1;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n}\n.days li.active::before {\n  background: #003da5;\n}\n.days li:not(.active):hover::before {\n  background: #003da5;\n}\n\n.customCalender .leftArrow img,\n.customCalender .rightArrow img {\n  filter: invert(100%) sepia(100%) saturate(10000%) hue-rotate(180deg);\n  transform: rotate(-90deg);\n  width: 12px;\n  height: 8px;\n}\n\n.customCalender .rightArrow img {\n  transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
